var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1665,
    cy: 39.5,
    r: 34.4125,
    stroke: "#FAFDFF",
    strokeWidth: 2.175
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1665 68C55.9066 68 68.6665 55.2401 68.6665 39.5C68.6665 23.7599 55.9066 11 40.1665 11C24.4264 11 11.6665 23.7599 11.6665 39.5",
    stroke: "#A3D8F4",
    strokeWidth: 2.175,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.7624C24 25.7641 26.6117 23.3335 29.8333 23.3335C33.055 23.3335 35.6667 25.7641 35.6667 28.7624C35.6667 31.7371 33.8049 35.2084 30.9001 36.4498C30.2229 36.7392 29.4438 36.7392 28.7666 36.4498C25.8618 35.2084 24 31.7371 24 28.7624Z",
    stroke: "#FAFDFF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.666 48.7624C45.666 45.7641 48.2777 43.3335 51.4993 43.3335C54.721 43.3335 57.3327 45.7641 57.3327 48.7624C57.3327 51.7371 55.4709 55.2084 52.5661 56.4498C51.8889 56.7392 51.1098 56.7392 50.4326 56.4498C47.5278 55.2084 45.666 51.7371 45.666 48.7624Z",
    stroke: "#FAFDFF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1663 49.1667C53.1663 50.0871 52.4201 50.8333 51.4997 50.8333C50.5792 50.8333 49.833 50.0871 49.833 49.1667C49.833 48.2462 50.5792 47.5 51.4997 47.5C52.4201 47.5 53.1663 48.2462 53.1663 49.1667Z",
    fill: "#FAFDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4998 29.1667C31.4998 30.0871 30.7536 30.8333 29.8332 30.8333C28.9127 30.8333 28.1665 30.0871 28.1665 29.1667C28.1665 28.2462 28.9127 27.5 29.8332 27.5C30.7536 27.5 31.4998 28.2462 31.4998 29.1667Z",
    fill: "#FAFDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6662 26.833C39.8378 26.833 39.1662 27.5046 39.1662 28.333C39.1662 29.1614 39.8378 29.833 40.6662 29.833V26.833ZM40.6662 51.6663L41.7269 52.727C42.3127 52.1412 42.3127 51.1915 41.7269 50.6057L40.6662 51.6663ZM49.3423 34.4785L50.1476 35.744L49.3423 34.4785ZM31.9902 45.5208L32.7955 46.7863H32.7955L31.9902 45.5208ZM39.2269 48.1057C38.6411 47.5199 37.6913 47.5199 37.1056 48.1057C36.5198 48.6915 36.5198 49.6412 37.1056 50.227L39.2269 48.1057ZM37.1056 53.1057C36.5198 53.6915 36.5198 54.6412 37.1056 55.227C37.6913 55.8128 38.6411 55.8128 39.2269 55.227L37.1056 53.1057ZM47.5527 26.833H40.6662V29.833H47.5527V26.833ZM40.6662 50.1663H33.7797V53.1663H40.6662V50.1663ZM48.537 33.2131L31.1849 44.2553L32.7955 46.7863L50.1476 35.744L48.537 33.2131ZM41.7269 50.6057L39.2269 48.1057L37.1056 50.227L39.6056 52.727L41.7269 50.6057ZM39.6056 50.6057L37.1056 53.1057L39.2269 55.227L41.7269 52.727L39.6056 50.6057ZM33.7797 50.1663C31.9456 50.1663 31.2481 47.771 32.7955 46.7863L31.1849 44.2553C27.1053 46.8514 28.9442 53.1663 33.7797 53.1663V50.1663ZM47.5527 29.833C49.3868 29.833 50.0844 32.2283 48.537 33.2131L50.1476 35.744C54.2271 33.148 52.3882 26.833 47.5527 26.833V29.833Z",
    fill: "#FAFDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructIconTwo);
export default __webpack_public_path__ + "static/media/instructIconTwo.d0d64e5c4c18fba7b2a140b2a686b793.svg";
export { ForwardRef as ReactComponent };